import { esc } from '../core/state.js';

const TIERS = ['악3', '악2', '악1', '중립', '선1', '선2', '선3'];
const COLORS = ['#ef7777', '#ed9480', '#e5b196', '#c4bba8', '#95cabb', '#87d3d1', '#c7e7aa'];
const num = n => Number(n).toLocaleString('ko-KR');

/** The server decides the tier and protection. The client only displays them. */
export function alignmentSummary(a, detail = true) {
  if (!a || !Number.isFinite(a.score) || !Number.isInteger(a.tier) || Math.abs(a.tier) > 3) return '';
  const label = esc(a.label || TIERS[a.tier + 3]);
  const state = a.on === false ? '성향 효과 꺼짐' : a.protected ? '사망 시 장비 보호 중' : '선3부터 사망 시 장비 보호';
  const next = Number.isFinite(a.nextThreshold)
    ? `<small>다음 단계까지 ${num(Math.max(0, a.nextThreshold - a.score))}점</small>`
    : '<small>최고 성향 단계</small>';
  return '<section class="sec alignment-card" aria-label="성향치">'
    + `<h3>성향치 <span style="color:${COLORS[a.tier + 3]}">${label}</span></h3>`
    + `<div class="kv"><span>${state}</span><b>${num(a.score)}점</b></div>${next}`
    + (detail ? '<details><summary>성향 올리기 · 장비 보호</summary>' + alignmentHelp(a) + '</details>' : '')
    + '</section>';
}

export function alignmentHelp(a) {
  const rules = a?.rules || a;
  const kills = rules?.playerKillPenalty === false ? '원주민을' : '원주민이나 다른 플레이어를';
  let h = '<p style="display:flex;gap:8px;flex-wrap:wrap">' + TIERS.map((name, i) =>
    `<span style="color:${COLORS[i]}"${a?.tier === i - 3 ? ' aria-current="step"' : ''}>${name}</span>`).join('') + '</p>'
    + '<p>선3에서는 착용 장비와 가방 속 장비를 죽어도 떨어뜨리지 않는다. 은화·일반 재료와 경험치 손실은 기존 규칙을 따른다. 유물 날개·귀속 장비의 기존 보호 효과도 유지된다.</p>'
    + `<p>${kills} 처치하면 선·중립은 즉시 악1로, 악1은 악2로, 악2는 악3으로 내려간다. 사냥과 거래, 도박·기부·투자로 다시 올릴 수 있다. 새 세계에서는 중립으로 시작한다.</p>`;
  if (rules && Number.isFinite(rules.huntPoints)) {
    h += '<p>' + (rules.huntPoints > 0 ? `몬스터 처치 1마리당 ${num(rules.huntPoints)}점. ` : '사냥 성향 보상은 꺼져 있다. ')
      + `실제 지출 ${num(rules.spendSilverPerPoint)}은화당 1점, 원주민 매입 거래 ${num(rules.tradeSilverPerPoint)}은화당 1점. `
      + `생명의 돌 봉헌은 1개당 ${num(rules.offeringPoints)}점이다. 도박은 정상 정산된 판돈을 기준으로 하며 환불은 포함하지 않는다.</p>`;
  }
  return h;
}
